export default __webpack_public_path__ + "static/media/about_tablet.f69f7f4d.png";